import type { FieldError } from 'react-hook-form';

import { t } from 'i18next';

export const translateErrorMessage = (error: FieldError) => {
  if (error.type === 'required') {
    return t('FieldIsRequired');
  }

  return t(error.message as string);
};
